import { render, staticRenderFns } from "./ItemDYCHD.vue?vue&type=template&id=cdaa8b64&scoped=true"
import script from "./ItemDYCHD.vue?vue&type=script&lang=js"
export * from "./ItemDYCHD.vue?vue&type=script&lang=js"
import style0 from "./ItemDYCHD.vue?vue&type=style&index=0&id=cdaa8b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdaa8b64",
  null
  
)

export default component.exports